import {Component, OnInit} from '@angular/core';
import {MenuItem} from 'primeng/api';

import {KeycloakSupportService, UserService} from '@app/core';
import {Roles, RouteLink} from '@app/shared';
import {BehaviorSubject} from 'rxjs';
import {QlikAppName} from '@app/shared/enums/qlik-app-name.enum';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['../../../assets/css/icons.css', '../../../assets/css/responsee.css', './home.component.css']
})


export class HomeComponent implements OnInit {

  public breadcrumb: MenuItem[] = [];
  Roles: typeof Roles = Roles;

  RouteLink: typeof RouteLink = RouteLink;
  showQlikComponent: boolean;
  displayA: boolean;
  displayB: boolean;
  displayC: boolean;
  displayD: boolean;
  displayE: boolean;
  displayF: boolean;
  displayG: boolean;
  displayH: boolean;
  displayI: boolean;
  displayJ: boolean;


  static initializedSub1: BehaviorSubject<boolean> = new BehaviorSubject(false);
  static sharedMsg1 = HomeComponent.initializedSub1.asObservable();

  QlikAppName: typeof QlikAppName = QlikAppName;


  constructor(public user: UserService, private keycloakSupport: KeycloakSupportService) {
    this.showQlikComponent = false;
  }

  ngOnInit() {
    this.user.routedIfCandidateOrCustomer();
  }

  qlikDashBoardPunchOut() {
    this.showQlikComponent = true;
    HomeComponent.initializedSub1.next(true);
    setTimeout(() => this.showQlikComponent = false, 10);
  }

  qlikPunchOut(component?: QlikAppName) {
    this.keycloakSupport.punchOutToQlik(component);
  }

}
